/* ==========================================================================
   Cart drawer: reset the inner scroll position whenever it opens or its
   contents are rebuilt.

   Verified against the real theme source (assets/pubsub.js confirms
   EVENTS.* are plain document-level CustomEvents under the hood, not an
   opaque pub/sub system, so listening for their string names directly
   here is safe and won't miss anything):

     - assets/cart-drawer.js HeaderCart.open() does
       `this.wrapper.scrollTop = 0` and also dispatches a genuine DOM
       event, document.dispatchEvent(new CustomEvent('CartDrawer:open')),
       right after adding the "is-active" class.
     - assets/cart-form.js CartForm.cartMarkup() — called by buildCart(),
       itself called from HeaderCart.handleCartChange() every time
       EVENTS.ajaxProductAdded ('ajaxProduct:added') fires — wipes and
       re-appends the product markup: `this.products.innerHTML = ''` then
       `this.products.append(items)`, where `this.products` is
       `form.querySelector('[data-products]')`, which lives directly
       inside `.cart__scrollable` (see snippets/header-cart-drawer.liquid).

   In the theme's original design, #HeaderCart itself was the scrolling
   element (overflow-y: auto directly on .site-header__drawer in
   components.css), so `this.wrapper.scrollTop = 0` correctly reset the
   visible scroll position on open. Our right-side, full-height redesign
   moves the actual scrolling into an inner element, .cart__scrollable
   (so the footer/checkout can stay pinned to the bottom of a
   full-height drawer instead of being wherever the content happens to
   end) — so the theme's own reset now touches an element that no longer
   does the scrolling, and .cart__scrollable can be left scrolled away
   from the top, making the first product look "clipped" when it has
   actually just scrolled out of view above the visible area.

   This resets .cart__scrollable's scrollTop at both real trigger points:
   the drawer opening, and the product markup being rebuilt shortly after
   (which happens asynchronously, right after open, whenever an item is
   added — see handleCartChange() awaiting buildCart() before opening).
   ========================================================================== */
(function () {
  function resetScroll() {
    var cart = document.getElementById('HeaderCart')
    if (!cart) return
    var scrollable = cart.querySelector('.cart__scrollable')
    if (scrollable) {
      scrollable.scrollTop = 0
    }
  }

  // Fires right after HeaderCart.open() adds "is-active" — components.css's
  // slide/fade transition is still running at this point, but resetting
  // scrollTop before paint is safe and avoids any visible jump.
  document.addEventListener('CartDrawer:open', resetScroll)

  // Fires whenever a product is added and the cart contents get rebuilt
  // (CartForm.cartMarkup replaces .cart__scrollable's [data-products]
  // content). Reset again here since this can happen after the drawer is
  // already open, or asynchronously right as it's opening.
  document.addEventListener('ajaxProduct:added', function () {
    // cartMarkup() runs inside an async .then() chain kicked off by this
    // same event, so give it a moment to actually finish swapping the
    // markup in before resetting scroll.
    setTimeout(resetScroll, 0)
    setTimeout(resetScroll, 100)
  })
})()